"use client"
import { useEffect } from 'react'
import { gtmPush, waitForPageView } from '../../utils/gtmHelpers'
import { GtmPageType } from '../../../domain/gtm'


export default function GtmPushEvent(props: {
  event: string
  afterPageView?: GtmPageType
}) {

  const {
    event,
    afterPageView
  } = props;

  useEffect(() => {
    if (afterPageView) {
      const aborted = { value: false };
      (async () => {
        await waitForPageView(afterPageView, aborted)
        if (aborted.value) {
          return;
        }
        gtmPush({
          event,
        })
      })()
      return () => {
        aborted.value = true;
      }
    }
    gtmPush({
      event,
    })
  }, [event, afterPageView])

  return null
}
